import { QueryKey } from '@tanstack/react-query';
import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import {
  GlobalSearchParams,
  SearchableEntityType,
} from '../../../modules/global-search/globalSearch.types';
import { serializeEntityTypes } from './globalSearch.serializers';

export const getGlobalSearchKey = (
  params: GlobalSearchParams,
  brandId?: string,
): UseDataQuery['queryKey'] => [
  'global-search',
  brandId,
  {
    q: params.q,
    entityTypes: serializeEntityTypes(params.entityTypes),
    skip: params.skip,
    limit: params.limit,
  },
];

interface GlobalSearchDrillDownKeyParams {
  q: string;
  entityType: SearchableEntityType;
  startSkip: number;
}

export const getGlobalSearchDrillDownKey = (
  params: GlobalSearchDrillDownKeyParams,
  brandId?: string,
): QueryKey => [
  'global-search-drill-down',
  brandId,
  {
    q: params.q,
    entityType: params.entityType,
    startSkip: params.startSkip,
  },
];
